export default __webpack_public_path__ + "static/media/simpleServo.015a41e3.svg";